// Dependency
import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby";
import { Link } from 'gatsby';

// Styles
import * as styles from './countdown.module.scss';

// Template
function Countdown(props) {
  const data = useStaticQuery(graphql`
      query {
        datoCmsCountdown{
            _allTextLocales{
              value
              locale
            }
            _allLinkLocales{
              value
              locale
            }
            link
            date
        }
      }
    `);

  const localeMap = {
    se: 'sv-SE',
    dk: 'da',
    eu: 'en',
    no: 'no',
    nl: 'nl',
    fr: 'en',
    uk: 'en-GB'
  }

  const counterData = data.datoCmsCountdown

  let counterText = counterData._allTextLocales.filter((textLocale) => {
    return textLocale.locale === localeMap[props.country];
  });

  let counterLink = counterData._allLinkLocales.filter((textLocale) => {
    return textLocale.locale === localeMap[props.country];
  });


  const [counter, setCounter] = useState("")

  useEffect(() => {
    const countDown = () => {
      let countDownDate = new Date(data.datoCmsCountdown.date).getTime()
      let x = setInterval(function () {
        let now = new Date().getTime()
        let distance = countDownDate - now
        let days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString()
        let hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        ).toString()
        let minutes = Math.floor(
          (distance % (1000 * 60 * 60)) / (1000 * 60)
        ).toString()
        let seconds = Math.floor((distance % (1000 * 60)) / 1000).toString()
        setCounter(days + "d " + hours + "h " + minutes + "m " + seconds + "s ")

        if (distance < 0) {
          clearInterval(x)
          setCounter("")
        }
      }, 1000)
    }

    countDown()
  }, [data.datoCmsCountdown.date])

  return (
    <div className={styles.cdCountdown}>
      {counterText && counterText[0] && counterText[0].value &&
        <p style={{ color: props.color }}>{counterText[0].value}</p>
      }
      {data.datoCmsCountdown.date !== "" && <span>{counter}</span>}
      {data.datoCmsCountdown.link &&
        <Link className='cd-absolute-link' to={`/${props.country}${counterLink[0].value}`}></Link>
      }
    </div>
  );
}

export default Countdown;